import { isSameDay } from 'date-fns';

export const testEndDate = (
  startDate: Date | null,
  minEndDate: Date | undefined,
  endDate: Date | null,
  disabledDates: Date[]
): boolean => {
  if (!startDate || !endDate) {
    return true;
  }

  // Check if endDate is before minEndDate
  if (minEndDate && endDate < minEndDate) {
    return false;
  }

  if (isSameDay(startDate, endDate)) {
    return true;
  }

  // Check if endDate is before startDate
  if (endDate < startDate) {
    return false;
  }

  // Check if endDate is in the disabled dates
  if (disabledDates.some((d) => isSameDay(endDate, d))) {
    return false;
  }

  const enabledYears = new Set(disabledDates.map((date) => date.getFullYear()));

  // Check if endDate's year is in the enabled years
  if (!enabledYears.has(endDate.getFullYear())) {
    return false;
  }

  return true;
};
